import React from "react";
import { useRegDetail } from "shared/context/regDetail";

export function LogoOnlyHeaderForMobile() {
  const { logoUrl } = useRegDetail();
  return (
    <React.Fragment>
      {logoUrl && (
        <header className="myExpheader">
          <div className="featureNotAvailable_header">
            <img alt="" src={logoUrl} />
          </div>
        </header>
      )}
    </React.Fragment>
  );
}
